import React from 'react';
import { PINK } from 'theme/colors';
import { Flex, FlexProps } from 'rebass';
import { CssTypeFix } from 'types/types';
import { LoadingSpinner } from 'components/LoadingSpinner/LoadingSpinner';

type Props = FlexProps &
  CssTypeFix & {
    isLoading: boolean;
    children?: React.ReactNode;
    size?: number;
    spinnerColor?: string;
    loadingLabel?: string;
  };

const SR_ONLY_STYLE: React.CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  borderWidth: 0,
};

export const Loader = ({
  isLoading,
  children = null,
  size = 50,
  spinnerColor = PINK,
  loadingLabel = 'Loading',
  ...restProps
}: Props) => {
  if (isLoading) {
    return (
      <Flex
        flex={1}
        justifyContent="center"
        alignItems="center"
        role="status"
        aria-live="polite"
        aria-busy="true"
        {...restProps}>
        <span style={SR_ONLY_STYLE}>{loadingLabel}</span>
        <LoadingSpinner size={size} spinnerColor={spinnerColor} />
      </Flex>
    );
  }
  return <>{children}</>;
};
